module.exports = __webpack_public_path__ + "static/media/celullaricon.e7b05452.svg";